import { selectUser } from 'app/auth/selectors';
import { useSelector } from 'react-redux';

export const useNotFoundErrorContent = () => {
  const user = useSelector(selectUser);

  return { user };
};

export type NotFoundErrorContentProps = ReturnType<typeof useNotFoundErrorContent>;
